<ng-container *ngIf="voteEnabled">
  <div class="text-center not-started" *ngIf="!voteEnabled.enabled">Perioada de vot nu a început încă!</div>
  <form [formGroup]="loginForm" class="d-flex flex-column justify-content-center align-items-center">
    <div class="d-flex justify-content-start align-items-center w-100">
      <mat-label>Email</mat-label>
    </div>
    <mat-form-field appearance="fill" floatLabel="always">
      <input formControlName="email" matInput placeholder="prenume.nume@student.upt.ro">
    </mat-form-field>
  </form>
</ng-container>

